import { identity } from '@kofno/piper';
import { Decoder, array, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../../../../../../Resource/Decoders';
import { ToString } from '../../../../../../../../../Options/Types';
import { ExtendedGroupOption, FilterOptions, FilterOptionsResource } from './Types';

const optionWithTypeDecoder = <T extends ToString>(
  decoder: Decoder<T>,
): Decoder<ExtendedGroupOption<T>> =>
  succeed({})
    .assign('label', field('label', string))
    .assign('value', field('value', decoder))
    .assign('participantCount', field('participant_count', number))
    .map<ExtendedGroupOption<T>>(identity);

const filterOptionsWithTypeDecoder: Decoder<FilterOptions> = array(optionWithTypeDecoder(string));

export const filterOptionsResourceDecoder: Decoder<FilterOptionsResource> = resourceDecoder(
  filterOptionsWithTypeDecoder,
);
